'use client'

import type { ProgressbarProps } from '@pearlconvert/ui/components/progressbar/progressbar.types'

import classNames from 'classnames'
import { type CSSProperties } from 'react'

import { useProgressbar } from '@pearlconvert/ui/components/progressbar/batons/use-progressbar'

import '@pearlconvert/ui/components/progressbar/styles/progressbar.scss'

export default function Progressbar(props: ProgressbarProps) {
  const { isLarge, className } = props
  const { progress } = useProgressbar({ progress: props.progress })

  const progressbarClass = classNames(
    'progressbar',
    {
      progressbar__large: isLarge,
      progressbar__finalColor: progress >= 100,
    },
    className
  )

  return (
    <div className={progressbarClass}>
      <div className="progressbar__bg"></div>
      <progress
        className="progressbar__progress"
        max="100"
        value={progress}
        style={{ '--progress__value': `${progress}%` } as CSSProperties}
        aria-hidden="true"
      />
    </div>
  )
}
